import { useMemo, useCallback } from 'react';
import { Filter, Stack } from '@fashionnovateam/nova-ui-toolkit';
import type { AppliedFilterItem } from '@fashionnovateam/nova-ui-toolkit';
import { buildFilterDefinitions } from './filter-config';
import {
  buildAppliedFilters,
  translateFiltersToValues,
} from './filter-transforms';
import type { SampleRequestFiltersProps } from './types';

export type { SampleRequestFilterValues } from './types';
export { readFiltersFromUrl, useUrlFilters } from './use-url-filters';

export function SampleRequestFilters({
  contacts,
  initialValue,
  onChange,
}: SampleRequestFiltersProps) {
  const filterDefinitions = useMemo(
    () => buildFilterDefinitions(contacts),
    [contacts],
  );
  const initialFilters = useMemo(
    () => (initialValue ? buildAppliedFilters(initialValue) : undefined),
    [initialValue],
  );
  const handleFilterChange = useCallback(
    (newFilters: AppliedFilterItem[]) => {
      onChange(translateFiltersToValues(newFilters));
    },
    [onChange],
  );

  return (
    <Stack
      direction="col"
      className="bg-neutral-100 p-2 xl:bg-neutral-0 border-b nu-border-neutral-200 xl:px-6 sticky top-0 left-0 z-10"
      data-testid="sample-request-filters"
    >
      <div className="relative">
        <Filter
          filterDefinitions={filterDefinitions}
          initialFilters={initialFilters}
          onFilterChange={handleFilterChange}
          allowDuplicateFilter={false}
          showSelectAll={false}
        />
      </div>
    </Stack>
  );
}
